import React, { useContext, createContext } from 'react';

import { PricingConfigStaticData } from '~shared/types/pricing/load-cache';
import { PricingExperience } from '~shared/types/pricing/pricingsvc';

// attempt to grab the cached experiments response to rehydrate when we make it to the browser
const win = typeof window !== 'undefined' ? window : undefined;
const payloadCache: PricingConfigStaticData | undefined =
  win && (win?.SM?.__LOAD_PAYLOAD_CACHE__ as PricingConfigStaticData);
const initialPricingExperience = (payloadCache?.pricingExperience || {}) as PricingExperience;

// NOOP API so the page doesn't explode on initial render
export const PackageDataContext = createContext<PricingExperience>(initialPricingExperience);

export const PackageDataProvider = ({
  pricingExperience,
  children,
}: {
  pricingExperience?: PricingExperience;
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <PackageDataContext.Provider value={pricingExperience ?? initialPricingExperience}>
      {children}
    </PackageDataContext.Provider>
  );
};

export const usePricingExperience = (): PricingExperience => useContext(PackageDataContext);
